import { render, staticRenderFns } from "./ord_suite_detail.vue?vue&type=template&id=1e35e1e1&scoped=true&"
import script from "./ord_suite_detail.vue?vue&type=script&lang=js&"
export * from "./ord_suite_detail.vue?vue&type=script&lang=js&"
import style0 from "./ord_suite_detail.vue?vue&type=style&index=0&id=1e35e1e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e35e1e1",
  null
  
)

export default component.exports